// src/app/auth/auth.service.ts

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { filter } from 'rxjs/operators';
import * as auth0 from 'auth0-js';

import { IcortexAccountsPortalUrlService } from './icortex-accounts-portal-url.service';
import { IcortexLocalizedPathService } from './icortex-localized-path.service';

(window as any).global = window;

@Injectable()
export class AuthService {

  auth0 = new auth0.WebAuth({
    clientID: 'FCCVOVepyYwzjicrtb6PrjgzC5D1Dxh1',
    domain: 'notbutton.auth0.com',
    responseType: 'token id_token',
    // redirectUri: 'http://localhost:4202/pages/loginAuth',
    redirectUri: 'https://accounts.icortex.ai/pages/loginAuth',
    scope: 'openid profile email'
  });

  public userProfile: any;
  // private lang:string = 'es'; //lang of login

  constructor(
    public router: Router,
    private readonly icortexAccountsPortalUrl: IcortexAccountsPortalUrlService,
    private readonly icortexLocalizedPathService: IcortexLocalizedPathService
  ) {}


  public handleAuthentication(): void {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        window.location.hash = '';
        this.setSession(authResult);
          this.router.navigate(['/pricing']);
      } else if (err) {
          console.log(err);
          this.router.navigate(['/home']);
      }
    });
  }

  public login(): void {

    window.location.href = this.icortexAccountsPortalUrl.getAccountsPortalOrigin();
  }

  public register(plan:string): void {

    if(plan == 'select'){
      this.router.navigate(['/pricing'])
    }else{
      localStorage.setItem('notBtWebPlanType', plan)
      this.router.navigateByUrl( this.icortexLocalizedPathService.getLocalizedPath( '/signup' ) );
    }
    // this.auth0.authorize({language: this.lang});
  }

  private setSession(authResult:any): void {
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
  }

  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // Go back to the home route
    this.router.navigate(['/']);
  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // Access Token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at') || '{}');
    return new Date().getTime() < expiresAt;
  }

  public getProfile(cb:any): void {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('Access Token must exist to fetch profile');
    }

    const self = this;
    this.auth0.client.userInfo(accessToken, (err, profile) => {
      if (profile) {
        self.userProfile = profile;
      }
      cb(err, profile);
    });
  }


}
